import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Modal } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { Formik } from 'formik';
import { Form, FormItem, Input } from 'formik-antd';

import Client from 'containers/app/client';

import './style.css';

const TokensCell = ({ tokens, id }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleSubmit = async (values) => {
    try {
      await Client.db.doc(`users/${id}`).set(
        {
          tokens: values.tokens,
        },
        { merge: true }
      );
      setIsModalOpen(false);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <Button
        onClick={() => {
          setIsModalOpen(true);
        }}
      >
        {tokens} <EditOutlined />
      </Button>
      <Formik initialValues={{ tokens }} onSubmit={handleSubmit}>
        {({ isSubmitting, resetForm }) => {
          const onCancel = () => {
            resetForm();
            setIsModalOpen(false);
          };
          return (
            <Modal
              className="change-tokens-modal"
              title="Change tokens for worker"
              visible={isModalOpen}
              footer={null}
              onCancel={onCancel}
            >
              <Form layout="vertical" className="wrapper">
                <FormItem label="Tokens" name="tokens">
                  <Input type="number" name="tokens" placeholder="00" />
                </FormItem>
                <Row gutter={16} type="flex" justify="flex-end" align="middle">
                  <Col>
                    <Button disabled={isSubmitting} onClick={onCancel}>
                      Cancel
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={isSubmitting}
                      disabled={isSubmitting}
                    >
                      Save
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Modal>
          );
        }}
      </Formik>
    </>
  );
};

TokensCell.propTypes = {
  tokens: PropTypes.number,
  id: PropTypes.string.isRequired,
};

TokensCell.defaultProps = {
  tokens: 0,
};

export default TokensCell;
